module.exports = __webpack_public_path__ + "img/homePage.c6dd521a.png";